import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth';
import { connectFirestoreEmulator } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getFirestore } from './fs';

// Modo emulador LOCAL únicamente (VITE_USE_EMULATORS=1 + projectId demo-*).
// No usa credenciales reales: los VITE_FB_* del mode emulator son ficticios.
// Producción / preview normal: sin este flag, comportamiento intacto.
export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === '1';

const projectId = import.meta.env.VITE_FB_PROJECT_ID;
if (USE_EMULATORS) {
  const pid = String(projectId || 'demo-vetpanel');
  // Defensa dura: prefijo demo- obligatorio; aborta el arranque del cliente.
  if (!pid.startsWith('demo-')) {
    throw new Error(
      `[firebase] Modo emulador activo pero VITE_FB_PROJECT_ID="${pid}" no empieza por "demo-". `
      + 'Abortado para no apuntar a un proyecto real. Usa demo-vetpanel (ver docs/EMULADOR.md).',
    );
  }
}

export const app = initializeApp({
  apiKey: import.meta.env.VITE_FB_API_KEY || (USE_EMULATORS ? 'demo-api-key' : undefined),
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN || (USE_EMULATORS ? 'demo-vetpanel.firebaseapp.com' : undefined),
  projectId: projectId || (USE_EMULATORS ? 'demo-vetpanel' : undefined),
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET || (USE_EMULATORS ? 'demo-vetpanel.appspot.com' : undefined),
  appId: import.meta.env.VITE_FB_APP_ID || (USE_EMULATORS ? '1:1:web:demo' : undefined),
  messagingSenderId: import.meta.env.VITE_FB_SENDER_ID || (USE_EMULATORS ? '1' : undefined),
});

export const auth = getAuth(app);
export const google = new GoogleAuthProvider();
// Siempre deja elegir cuenta (si no, entra solo con la última usada)
google.setCustomParameters({ prompt: 'select_account' });
export const db = getFirestore(app);

if (USE_EMULATORS) {
  connectAuthEmulator(auth, import.meta.env.VITE_FIREBASE_AUTH_EMULATOR || 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(
    db,
    import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || '127.0.0.1',
    Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT || 8080),
  );
}

export const functions = getFunctions(app, 'europe-southwest1');
// AUD-FN-01: en modo emulador las funciones (callables) también van al emulador local, nunca a Cloud real
if (USE_EMULATORS) {
  connectFunctionsEmulator(
    functions,
    import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST || '127.0.0.1',
    Number(import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT || 5001),
  );
  // eslint-disable-next-line no-console
  console.info('[firebase] Emuladores Auth+Firestore+Functions (proyecto', app.options.projectId, ')');
}
